import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = location.state?.userId;

  // const handlePayment = async () => {

  //   const { data: order } = await axios.post(
  //     "http://localhost:4000/payment/create-order"
  //   );

  //   const options = {
  //     key: "rzp_test_SHyXNCfuKXSkUX",
  //     amount: order.amount,
  //     currency: order.currency,
  //     order_id: order.id,

  //     handler: async function (response) {

  //       await axios.post(
  //         "http://localhost:4000/payment/verify-payment",
  //         { ...response, userId }
  //       );

  //       navigate("/dashboard");
  //     }
  //   };

  //   const rzp = new window.Razorpay(options);
  //   rzp.open();
  // };
const handlePayment = async () => {
  try {
    const { data: order } = await axios.post(
      `${process.env.REACT_APP_FRONTEND_URL}/payment/create-order`,
      {},
      { withCredentials: true }
    );

    const options = {
    key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: order.amount,
      currency: order.currency,
      order_id: order.id,

      handler: async function (response) {
        await axios.post(
          `${process.env.REACT_APP_FRONTEND_URL}/payment/verify-payment`,
          response,
          { withCredentials: true }
        );

        navigate("/dashboard");
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    console.log("Payment Error:", err);
  }
};
  return (
<div className="payment-page">
  <div className="payment-card">
    <h2 className="title">Upgrade to Premium</h2>

    <p className="price">₹{process.env.REACT_APP_FRONTEND_PAY}</p>
    <p className="duration">30 Days Unlimited Access</p>

    <ul className="features">
      <li>✔ Full Dashboard Access</li>
      <li>✔ Member Management System</li>
      <li>✔ Secure Subscription Access </li>
      <li>✔ Priority Support</li>
    </ul>

    <button onClick={handlePayment} className="pay-btn">
      Pay Now
    </button>
  </div>
</div>
  );
};

export default Payment;